import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Products from "../src/components/Products";
import Accompaniment from "../src/components/Accompaniment";
import Experiences from "../src/components/Experiences";
import Testimonials from "../src/components/Testimonials";
import Embajadoras from "./components/Embajadoras";
import About from "../src/components/About";
import Navbar from "./components/Navbar";
import WhatsAppPresence from "./components/WhatsappSticky";
import AdminApp from "./admin/AdminApp";  // ← nuevo

function Layout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/productos" element={<Products />} />
        <Route path="/acompanamiento" element={<Accompaniment />} />
        <Route path="/experiencias" element={<Experiences />} />
        <Route path="/testimonios" element={<Testimonials />} />
        <Route path="/embajadoras" element={<Embajadoras />} />
        <Route path="/sobre-mi" element={<About />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>

      {!isAdmin && <WhatsAppPresence />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;

